export default __webpack_public_path__ + "static/avatar-kayi-sketch-0-2d5193964e06910717eab636c14e9f31.png";